import { useGoogleFontsStore } from "@/stores/google-fonts/index.ts";
import { useStore } from "vuex";

export default function useSettingsData() {
  const store = useStore();
  async function loadSettingsData(to) {
    const promises = [
      store.dispatch("api/fetchCategoryTree"),
      store.dispatch("api/fetchStylingData", store.getters.getStyleID),
    ];

    if (to.name === "RocketCast") {
      promises.push(store.dispatch("api/fetchAllCastScreens"));
    }

    if (to.name === "Fonts") {
      const googleFontsStore = useGoogleFontsStore();
      promises.push(googleFontsStore.load());
    }

    if (to.name === "Users") {
      promises.push(store.dispatch("api/fetchUsers"));
    }

    await Promise.all(promises);
  }
  return {
    loadSettingsData,
  };
}
